import { render, staticRenderFns } from "./SingleBackOrderView.vue?vue&type=template&id=56b8a7a0&scoped=true&xmlns%3Av-touch=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./SingleBackOrderView.vue?vue&type=script&lang=js"
export * from "./SingleBackOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8a7a0",
  null
  
)

export default component.exports